
export default {

    settings(state){
        return state.settings
    },

    setting(state){
        return state.setting
    },

    referralBonusSetting(state){
       return state.referralBonusSetting
    },

    upgradeBonusSetting(state){
        return state.upgradeBonusSetting
    },

    unilevelBonusSetting(state){
        return state.unilevelBonusSetting
    },

    stockistUplineBonusSetting(state){
        return state.stockistUplineBonusSetting
    }
}